// Libs
import { Box } from '@mui/material';
import classNames from 'classnames/bind';
import { ReactNode } from 'react';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './EventContainer.module.scss';

type Props = {
  children: ReactNode;
  onClick?: () => void;
};

const cx = classNames.bind(styles);

const EventContainer = (props: Props) => {
  //#region Destructuring Props
  const { children, onClick } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleClick = () => {
    onClick && onClick();
  };
  //#endregion Handle Function

  return (
    <Box className={cx('eventContainer')} component={'div'}>
      <Box component={'div'} onClick={handleClick} className={cx('eventItem')}>
        {children}
      </Box>
    </Box>
  );
};

export default EventContainer;
